var WDN = WDN || {};

if (typeof WDN.StoreHandler === "undefined") {
  WDN.StoreHandler = (function () {
    var init;
    // Location functions
    var fetchUserLocation, onLocationFetchSuccess, onLocationFetchError;

    // Storage & URL
    var readLocationParam, clearURLParams;

    // Config - Coming from theme.liquid
    var config = WDN.StoreHandlerConfig;

    var nodes = {
      countryPopup: document.querySelector("wdn-modal[data-id='countrypopup']"),
    };

    /* COUNTRY POPUP - START 
      - open
      - onClose
      - configure
    */
    var CountyPopup = {
      open: function () {
        nodes.countryPopup.open();
      },
      onClose: function () {
        // If 'No thanks' clicked - set location based on current store
        if (document.querySelector("[data-country-denied]")) {
          Shipping.configure();
          return;
        }

        // Redirect
        window.location.href = this.redirectURL;
      },
      configure: function (popupConfig) {
        /*
          popupConfig:
          @layout: [string]
          @iso: [string]
        */
        // Inject layout
        var output = document.querySelector(".country-select [data-country-options]");
        output.innerHTML = popupConfig.layout;

        // Select link node (button)
        var link = output.querySelector("a");
        var host = link.getAttribute("data-host");
        var path = config.currentStore.path;
        var params = link.getAttribute("data-params");

        // Set redirect URL
        this.redirectURL = host + path + params;
        link.setAttribute("href", this.redirectURL);

        // Listen for Close
        document.body.addEventListener(
          "overlay:closed",
          function (e) {
            if (e.detail.id === "countrypopup") {
              this.onClose();
            }
          }.bind(this)
        );
      },
    };
    /* COUNTRY POPUP - END */

    /* Shipping - START */
    var Shipping = {
      /*
        Configuration example
        {
          "iso": "DK",
          "price": 9000,
          "threshold": 7500
        }
      
      */
      configure: function (configuration) {
        // If no configuration passed - use the default one
        if (!configuration) {
          configuration = config.currentStore;
        }

        // Set session storage
        sessionStorage.setItem(config.locationKey, configuration.iso);

        // Clear params
        clearURLParams();
      },
    };
    /* Shipping - END */

    var Store = {
      configure: function (iso) {
        this.iso = iso;
        var searchParams = new URLSearchParams();

        // Add query
        searchParams.set("q", iso);
        searchParams.set("sections", "async-country-popup,async-store-configuration");

        // Fetch Country Configuration
        WDN.Request.Get({
          url: Shopify.routes.root + "search?" + searchParams.toString(),
          type: "JSON",
          onSuccess: this.onRequestSuccess.bind(this),
          onError: this.onRequestError.bind(this),
        });
      },
      // Handles search success
      onRequestSuccess: function (res) {
        var domParser = new DOMParser();
        // Parse response from section 'async-store-configuration'
        var parsedResponse = domParser.parseFromString(res["async-store-configuration"], "text/html");
        // Parse JSON dump from the response
        var searchConfiguration = JSON.parse(parsedResponse.querySelector("[data-store-configuration]").innerText);
        // Check if redirect url is "" (market) and requested ISO not found in localization
        var marketNotInLocalization = searchConfiguration.store.url === "" && searchConfiguration.foundInLocalization === false;

        // Handle user on correct market store / localization not found (use default)
        if (searchConfiguration.marketMatch || marketNotInLocalization) {
          Shipping.configure();
          return;
        }

        // If store has the same host as primary market and user redirected
        if (searchConfiguration.store.url === "" && readLocationParam()) {
          // Configure shipping based on the search response
          Shipping.configure(searchConfiguration.store);
          return;
        }

        // Handle user not on correct store
        // Configure country popup
        WDN.StylesheetLoader.load(".countrypopup-style");
        CountyPopup.configure({
          layout: res["async-country-popup"],
          iso: this.iso,
        });
        // Open country popup
        CountyPopup.open();
      },

      // Handles search error
      onRequestError: function () {
        // If request failed - keep user on the same store
        Shipping.configure();
      },
    };

    readLocationParam = function () {
      var searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(config.locationKey);
    };

    var readStorage = function () {
      return sessionStorage.getItem(config.locationKey);
    };

    var readCountryParam = function () {
      var searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(config.countryKey);
    };

    clearURLParams = function () {
      var paramsToDelete = [config.redirectKey, config.locationKey, config.countryKey];
      var searchParams = new URLSearchParams(window.location.search);
      // Delete URL params
      paramsToDelete.forEach(function (paramName) {
        searchParams.delete(paramName);
      });

      // Convert params to string
      var searchParamsString = searchParams.toString();
      var newState = "?" + searchParamsString;

      // If no params - do not append '?'
      if (searchParamsString.length === 0) {
        newState = location.pathname;
      }

      window.history.pushState("", "", newState);
    };

    // IP-API Request
    fetchUserLocation = function () {
      WDN.Request.Get({
        url: "https://pro.ip-api.com/json/?fields=49155&key=QlU1L3aD2drfrpr",
        type: "JSON",
        onSuccess: onLocationFetchSuccess,
        onError: onLocationFetchError,
      });
    };

    // IP-API Success Callback
    onLocationFetchSuccess = function (res) {
      Store.configure(res.countryCode);
    };

    // IP-API Error Callback
    onLocationFetchError = function (err) {
      // If request failed - keep user on the same store
      Shipping.configure();
    };

    init = function () {
      // If redirected, find configuration by iso coming from param value
      var locationParam = readLocationParam();
      var countryParam = readCountryParam();
      if (locationParam || countryParam) {
        var isoQuery = locationParam ? locationParam : countryParam;
        Store.configure(isoQuery);
        return;
      }

      // If stored location the same as liquid dump - read & use default values
      var storedPreference = readStorage();
      if (config.currentStore.iso === storedPreference) {
        Shipping.configure();
        return;
      }

      // Find configuration by stored iso code - if config not found - default values used
      if (storedPreference) {
        Store.configure(storedPreference);
        return;
      }

      // Handle new user - find location & configuration
      fetchUserLocation();
    };

    // Module start here
    init();

    return {
      Shipping: Shipping,
    };
  })();
}
